import { render, staticRenderFns } from "./micPermission.vue?vue&type=template&id=1918cb42&"
import script from "./micPermission.vue?vue&type=script&lang=js&"
export * from "./micPermission.vue?vue&type=script&lang=js&"
import style0 from "./micPermission.vue?vue&type=style&index=0&id=1918cb42&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports